import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/core/services/notification.service';
import { BranchOfficeModel } from 'src/app/core/models/branch-office.model';
import { UserService } from 'src/app/core/services/user.services';
import { BranchOfficeForm } from 'src/app/core/models/interfaces/forms/branch-office.form';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GenericPlace } from 'src/app/core/models/generic-place.model';
import { MyCommerceService } from 'src/app/core/services/my-commerce.service';
import { ConfirmarDialogComponent } from 'src/app/shared/components/confirmar-dialog/confirmar-dialog.component';
import { SearchPlaceComponent } from '../search-place/search-place.component';
import {
  allowDropOnlyLettersAndNumbers,
  allowOnlyLettersAndNumbers,
  allowPasteOnlyLettersAndNumbers
} from 'src/app/shared/functions/input-validations.functions';
import { pixPhoneHint, pixPhoneMask, regexsPhone } from 'src/app/core/utils/validators-input.service';

@Component({
  selector: 'app-create-edit-branch',
  templateUrl: './create-edit-branch.component.html',
  styleUrls: ['./create-edit-branch.component.scss']
})
export class CreateEditBranchComponent implements OnInit {
  private viewState: ABMState = ABMState.CREATE;
  private readonly DOMICILIO_COMERCIAL: string = 'address';
  private readonly SUCURSALES: string = 'branchs';

  @ViewChild(SearchPlaceComponent) searchPlace: SearchPlaceComponent;

  form: UntypedFormGroup;
  saving: boolean = false;
  currentEdition: BranchOfficeModel;
  branchOfficeSelect: any;
  editado: boolean = false;
  isEdit: boolean = false;
  nombre: string;
  telefono: string;
  direccion: string;
  selectedPlace: GenericPlace | null = null;
  userServices: any;
  pixPhoneMaskSelected = pixPhoneMask[1];
  pixPhoneHintSelected = pixPhoneHint[1];
  pixRegexsPhone: RegExp[] = regexsPhone;

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private userService: UserService,
    private route: ActivatedRoute,
    private myCommerceService: MyCommerceService
  ) {
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', Validators.required),
      address: new UntypedFormControl('', Validators.required),
      phone: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern(this.pixRegexsPhone[1])])
      ),
      ciudadControl: new UntypedFormControl('', Validators.required),
      calleControl: new UntypedFormControl('', Validators.required),
      numeroControl: new UntypedFormControl('', Validators.required),
      provinciaControl: new UntypedFormControl('', Validators.required),
      cpControl: new UntypedFormControl('', Validators.required),
      pisoControl: new UntypedFormControl(''),
      dptoControl: new UntypedFormControl('')
    });
  }

  async ngOnInit() {
    this.userServices = this.userService.getCurrentUser();

    this.route.queryParams.subscribe(async (val) => {
      if (val.branch) {
        this.isEdit = true;
        let branch = await this.myCommerceService.getSucursal(val.branch);
        let branchModel: BranchOfficeModel = new BranchOfficeModel();
        branchModel.address = branch.direccion;
        branchModel.id = branch.id;
        branchModel.name = branch.nombre;
        branchModel.phone = branch.telefono;
        branchModel.type = branch.tipo;

        console.log(branchModel);

        this.addToForm('address', branchModel.address);
        this.addToForm('name', branchModel.name);
        this.addToForm('phone', branchModel.phone);
        this.addToForm('ciudadControl', branch.ubicacion.ciudad);
        this.addToForm('calleControl', branch.ubicacion.calle);
        this.addToForm('numeroControl', branch.ubicacion.altura);
        this.addToForm('provinciaControl', branch.ubicacion.provincia);
        this.addToForm('cpControl', branch.ubicacion.codigoPostal);
        this.addToForm('pisoControl', branch.ubicacion.piso);
        this.addToForm('dptoControl', branch.ubicacion.departamento);
        this.currentEdition = branchModel;
        this.viewState = ABMState.EDITION;

        this.form.controls['address'].valueChanges.subscribe(
          () => (this.editado = this.validarEdicion() ? true : false)
        );
        this.form.controls['name'].valueChanges.subscribe(() => (this.editado = this.validarEdicion() ? true : false));
        this.form.controls['phone'].valueChanges.subscribe(() => (this.editado = this.validarEdicion() ? true : false));
      }
    });
  }

  validarEdicion() {
    if (this.currentEdition) {
      return true;
    } else {
      return false;
    }
  }

  buildForm(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      phone: ['', Validators.compose([Validators.required, Validators.pattern('[0-9 ]{11}')])]
    });
  }

  selectedPlaceEventHandler(place: GenericPlace | null): void {
    if (place) {
      this.selectedPlace = place;

      const match = place.nombreDireccion.match(/^(.*?)(\d+)(?:,.*?)?$/);
      const calle = match ? match[1].trim() : place.nombreDireccion;
      const numero = match ? match[2].trim() : '';

      this.form.get('calleControl')?.setValue(calle);
      this.form.get('numeroControl')?.setValue(numero);

      this.form.get('cpControl')?.setValue(place.codigoPostal);
      this.form.get('ciudadControl')?.setValue(place.ciudad);
      this.form.get('provinciaControl')?.setValue(place.provincia);

      this.form.get(this.DOMICILIO_COMERCIAL).setValue(place.nombreDireccion);
    } else {
      this.form.get(this.DOMICILIO_COMERCIAL).reset();
      this.form.get('calleControl')?.reset();
      this.form.get('numeroControl')?.reset();
      this.form.get('cpControl')?.reset();
      this.form.get('ciudadControl')?.reset();
      this.form.get('provinciaControl')?.reset();
    }
  }

  isValid(listCheck: any, formCntrl: AbstractControl): string {
    let errors: string = '';
    let errorsView: any;
    errorsView = new Array();
    listCheck.forEach((element) => {
      if (formCntrl.hasError(element.type) && (formCntrl.dirty || formCntrl.touched)) {
        errorsView.push(element);
        if (errorsView.find((t) => t.type == element.type)) {
          errors = element.messageKey;
        }
      }
    });

    return errors;
  }

  addToForm(input: string, value: string): void {
    this.form.get(input).setValue(value);
  }

  fillForm(model: BranchOfficeModel) {
    this.addToForm('name', model.name);
    setTimeout(() => {
      this.addToForm('address', model.address);
    }, 500);
    this.addToForm('phone', model.phone);
  }

  getCreateErrorMessage(): string {
    return this.translate('pages.branch_offices.messages.create.error');
  }

  getEditErrorMessage(): string {
    return this.translate('pages.branch_offices.messages.edit.error');
  }

  getCreateSuccessMessage(): string {
    return this.translate('pages.branch_offices.messages.create.success');
  }

  getEditSuccessMessage(): string {
    return this.translate('pages.branch_offices.messages.edit.success');
  }

  getConfirmationTitle(): string {
    return this.translate('pages.branch_offices.messages.confirm');
  }

  getConfirmationText(): string {
    return this.translate('pages.branch_offices.labels.confirm_title');
  }

  getBackRoute(): string {
    return '/user/branch-offices';
  }

  goBack() {
    this.router.navigate(['/user/my-commerce/branch']);
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }

  isEdition(): boolean {
    return this.viewState == ABMState.EDITION;
  }

  async userConfirmation(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        id: 1,
        title: this.getConfirmationTitle(),
        info: this.getConfirmationText()
      };

      const dialogRef = this.dialog.open(ConfirmarDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((response) => {
        resolve(response != '' && response);
      });
    });
  }

  getSuccessMessage(): string {
    if (this.viewState == ABMState.CREATE) {
      return this.getCreateSuccessMessage();
    } else {
      return this.getEditSuccessMessage();
    }
  }

  getErrorMessage(): string {
    if (this.viewState == ABMState.CREATE) {
      return this.getCreateErrorMessage();
    } else {
      return this.getEditErrorMessage();
    }
  }

  async onSubmitEventHandler(form: BranchOfficeForm): Promise<void> {
    sessionStorage.removeItem(this.SUCURSALES);
    try {
      if (this.isEdition()) {
        form.id = this.currentEdition.id;
        form.branchId = this.currentEdition.id;
        const userResponse = await this.userConfirmation();
        this.saving = true;
        if (!userResponse) {
          this.saving = false;
          return;
        }
      }

      form.latitud = this.selectedPlace?.latitud;
      form.longitud = this.selectedPlace?.longitud;
      form.pais = this.selectedPlace?.pais;
      form.placeId = this.selectedPlace?.placeId;
      form.esDepartamento = this.selectedPlace?.esDepartamento;

      let response = await this.userService.saveBranchOfficeNew(form);
      this.saving = true;
      if (response) {
        this.notificationService.showSuccess(this.getSuccessMessage());
        this.goBack();
      } else {
        throw new Error(this.getErrorMessage());
      }
      this.saving = false;
    } catch (error) {
      this.notificationService.showError(error.message);
    }
  }

  public onPisoInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const numericValue = input.value.replace(/[^0-9]/g, '');
    this.form.controls['pisoControl'].setValue(numericValue, { emitEvent: false });
  }

  public onDeptoInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const alphanumericValue = input.value.replace(/[^a-zA-Z0-9]/g, '');
    this.form.controls['deptoControl'].setValue(alphanumericValue, { emitEvent: false });
  }

  public onNroInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const numericValue = input.value.replace(/[^0-9]/g, '');
    this.form.controls['numeroControl'].setValue(numericValue, { emitEvent: false });
  }

  public checkPattern(event: KeyboardEvent) {
    allowOnlyLettersAndNumbers(event);
  }

  public checkPaste(event: ClipboardEvent) {
    allowPasteOnlyLettersAndNumbers(event);
  }

  public checkDrop(event: DragEvent) {
    allowDropOnlyLettersAndNumbers(event);
  }
}

enum ABMState {
  CREATE = 'C',
  EDITION = 'E'
}
